import {
  FETCH_HUBBLOG,
  FETCH_HUBBLOG_FAILURE,
  FETCH_HUBBLOG_SUCCESS,
  //
  ADD_HUBBLOG,
  ADD_HUBBLOG_SUCCESS,
  ADD_HUBBLOG_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  EDIT_HUBBLOG,
  EDIT_HUBBLOG_SUCCESS,
  EDIT_HUBBLOG_FAILURE,
  //
  DELETE_HUBBLOG,
  DELETE_HUBBLOG_SUCCESS,
  DELETE_HUBBLOG_FAILURE,
  //
  UPLOAD_MEDIA,
  UPLOAD_MEDIA_SUCCESS,
  UPLOAD_MEDIA_FAILURE,
} from "./constants";

export const fetchHubBlog = (payload, onSuccess) => ({
  type: FETCH_HUBBLOG,
  payload,
  onSuccess,
});
export const fetchHubBlogSuccess = (payload) => ({
  type: FETCH_HUBBLOG_SUCCESS,
  payload,
});
export const fetchHubBlogFailure = (payload) => ({
  type: FETCH_HUBBLOG_FAILURE,
  payload,
});

export const addHubBlog = (payload) => ({
  type: ADD_HUBBLOG,
  payload,
});
export const addHubBlogSuccess = (payload) => ({
  type: ADD_HUBBLOG_SUCCESS,
  payload,
});
export const addHubBlogFailure = (payload) => ({
  type: ADD_HUBBLOG_FAILURE,
  payload,
});

export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});

export const editHubBlog = (payload) => ({
  type: EDIT_HUBBLOG,
  payload,
});
export const editHubBlogSuccess = (payload) => ({
  type: EDIT_HUBBLOG_SUCCESS,
  payload,
});
export const editHubBlogFailure = (payload) => ({
  type: EDIT_HUBBLOG_FAILURE,
  payload,
});

export const deleteHubBlog = (payload, onDeleteSuccess) => ({
  type: DELETE_HUBBLOG,
  payload,
  onDeleteSuccess,
});
export const deleteHubBlogSuccess = (payload) => ({
  type: DELETE_HUBBLOG_SUCCESS,
  payload,
});
export const deleteHubBlogFailure = (payload) => ({
  type: DELETE_HUBBLOG_FAILURE,
  payload,
});

export const uploadMedia = (payload) => ({
  type: UPLOAD_MEDIA,
  payload,
});
export const uploadMediaSuccess = (payload) => ({
  type: UPLOAD_MEDIA_SUCCESS,
  payload,
});
export const uploadMediaFailure = (payload) => ({
  type: UPLOAD_MEDIA_FAILURE,
  payload,
});
